import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteFilterTemplateFailed, deleteFilterTemplateSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, BACKEND_URL_V2 } from '../../../configs';

export default function* deleteFilterTemplate(action) {
  try {
    const url = `${BACKEND_URL_V2}/filter-templates/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteFilterTemplateSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteFilterTemplateFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteFilterTemplateFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
